import '/assets/styles/pages/promotions.scss';
import { useEffect, useMemo, useState } from 'react';

// Context
import { useAuth } from '@wearetla/tla-essentials-tools/utilities/auth';
import { useModals } from '@wearetla/tla-essentials-tools/utilities/modals';
import { useTranslation } from '/utilities/i18n';

// Sections
import PageHeader from '/views/sections/page-header';

// Partials
import Btn from '/views/partials/btn';
import Img from '@wearetla/tla-essentials-tools/partials/img';
import Placeholder from '/views/partials/placeholder';

// Services
import siteServices from '/services/site';

const Promotions = () => {
	const { loggedIn, initialized: authInitialized } = useAuth();
	const { openModal } = useModals();
	const { t } = useTranslation();

	const [rawPromotions, setPromotions] = useState(null);

	// İçerik giriş durumuna göre değiştiği için oturum belli olana kadar placeholder gösterilir.
	const promotions = useMemo(
		() => (rawPromotions && authInitialized ? rawPromotions : [false, false, false]),
		[rawPromotions, authInitialized]
	);

	useEffect(() => {
		if (!rawPromotions) {
			siteServices
				.getPromotions()
				.then(setPromotions)
				.catch((feedback) => {
					openModal('message', { feedback });
				});
		}
	}, [rawPromotions]);

	return (
		<>
			<PageHeader icon="gift" backLink="home" backLinkRedirect title={t('Kampanyalar')} />
			<div className="promotions-wrap wrapper">
				<div className="promotions-list">
					{promotions.map((promotion, nth) => (
						<div className="list-item type-promotion" key={promotion?.id ?? `promo-${nth}`}>
							{promotion ? (
								<>
									<Img src={promotion.image} cover className="item-image" />
									<strong className="item-title">{promotion.title}</strong>
									<div
										className="item-description wysiwyg"
										dangerouslySetInnerHTML={{
											__html:
												(loggedIn && promotion.descriptionLoggedIn) || promotion.description || '',
										}}
									/>
									<PromotionCta cta={loggedIn ? promotion.cta?.loggedIn : promotion.cta?.guest} />
								</>
							) : (
								<>
									<Placeholder className="item-image" />
									<Placeholder className="item-title" />
									<Placeholder className="item-description" />
								</>
							)}
						</div>
					))}
				</div>
			</div>
		</>
	);
};

// `action: 'login'` giriş modalını açar; diğer durumda `href`/`params` rota anahtarı, `url` harici bağlantıdır.
const PromotionCta = ({ cta }) => {
	const { openModal } = useModals();

	if (!cta?.title) {
		return null;
	}

	if (cta.action === 'login') {
		return (
			<Btn
				className="item-cta primary block"
				onClick={() => {
					openModal('auth');
				}}
			>
				{cta.title}
			</Btn>
		);
	}

	if (cta.url) {
		return (
			<Btn tag="link" raw href={cta.url} target="_blank" className="item-cta primary block">
				{cta.title}
			</Btn>
		);
	}

	return (
		<Btn tag="link" href={cta.href} params={cta.params} className="item-cta primary block">
			{cta.title}
		</Btn>
	);
};

export default Promotions;
